import { View, Text } from "@react-pdf/renderer";
import { COLORS } from "../../settings/themeSettings";

const DashboardTablePDFII = ({ caption, data, title }) => {
    // Debug: Afficher les données reçues
    console.log(`DashboardTablePDFII - Caption: ${caption}`);
    console.log(`DashboardTablePDFII - Data:`, data);
    console.log(`DashboardTablePDFII - Title:`, title);

    // Protection contre les données vides
    if (!data || Object.keys(data).length === 0) {
        console.log(`DashboardTablePDFII - Aucune donnée pour ${caption}`);
        return <View style={{ width: '100%' }}>
            <Text style={{
                fontSize: 12,
                fontWeight: 'bold',
                color: 'white',
                backgroundColor: COLORS.secondary,
                textAlign: 'center',
                paddingVertical: 5,
                marginBottom: 10,
            }}>
                {caption} - Aucune donnée disponible
            </Text>
        </View>;
    }

    const dataKeys = Object.keys(data);
    console.log(`DashboardTablePDFII - DataKeys:`, dataKeys);

    return <View style={{ width: '100%' }} wrap={false}>
        {/* Titre du tableau */}
        <Text style={{
            fontSize: 12,
            fontWeight: 'bold',
            color: 'white',
            backgroundColor: COLORS.secondary,
            textAlign: 'center',
            paddingVertical: 5,
            marginBottom: 10,
        }}>
            {caption}
        </Text>

        {/* En-têtes */}
        <View style={{
            flexDirection: 'row',
            borderBottom: '1 solid #000',
            paddingBottom: 5,
            marginBottom: 5
        }}>
            <Text style={{
                width: '25%',
                fontSize: 10,
                fontWeight: 'bold',
                textAlign: 'center'
            }}>
                Libellé
            </Text>
            {title && title.map((tl, index) => (
                <View key={index} style={{ width: '25%', alignItems: 'center' }}>
                    <Text style={{
                        fontSize: 10,
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: 3
                    }}>
                        {tl}
                    </Text>
                    <View style={{ flexDirection: 'row', width: '100%' }}>
                        <Text style={{
                            width: '50%',
                            fontSize: 8,
                            textAlign: 'center'
                        }}>
                            Montant
                        </Text>
                        <Text style={{
                            width: '50%',
                            fontSize: 8,
                            textAlign: 'center'
                        }}>
                            %
                        </Text>
                    </View>
                </View>
            ))}
        </View>

        {/* Données */}
        {dataKeys.map((rowKey, rowIndex) => {
            console.log(`DashboardTablePDFII - Processing row: ${rowKey}`, data[rowKey]);
            return (
                <View key={rowIndex} style={{
                    flexDirection: 'row',
                    marginBottom: 3,
                    borderBottom: rowIndex === dataKeys.length - 1 ? '1 solid #000' : 'none'
                }}>
                    {/* Colonne libellé */}
                    <Text style={{
                        width: '25%',
                        fontSize: 9,
                        backgroundColor: COLORS.gray[200],
                        paddingHorizontal: 3,
                        paddingVertical: 8,
                        fontWeight: rowKey === 'TOTAL' ? 'bold' : 'normal'
                    }}>
                        {rowKey}
                    </Text>

                    {/* Colonnes de données */}
                    {title && title.map((columnTitle, columnIndex) => {
                        const cellData = data[rowKey] && data[rowKey][columnTitle];
                        console.log(`DashboardTablePDFII - Cell data for ${rowKey}-${columnTitle}:`, cellData);

                        if (Array.isArray(cellData)) {
                            // Format [montant, pourcentage]
                            return (
                                <View key={columnIndex} style={{
                                    width: '25%',
                                    flexDirection: 'row'
                                }}>
                                    <Text style={{
                                        width: '50%',
                                        fontSize: 8,
                                        backgroundColor: COLORS.gray[200],
                                        paddingHorizontal: 2,
                                        paddingVertical: 8,
                                        textAlign: 'right'
                                    }}>
                                        {String(cellData[0] || "0")}
                                    </Text>
                                    <Text style={{
                                        width: '50%',
                                        fontSize: 8,
                                        backgroundColor: 'transparent',
                                        paddingHorizontal: 2,
                                        paddingVertical: 8,
                                        textAlign: 'center',
                                        fontWeight: 'bold'
                                    }}>
                                        {String(cellData[1] || "0%").replace("NaN%", "0%")}
                                    </Text>
                                </View>
                            );
                        } else {
                            // Format simple
                            return (
                                <View key={columnIndex} style={{
                                    width: '25%',
                                    flexDirection: 'row'
                                }}>
                                    <Text style={{
                                        width: '100%',
                                        fontSize: 8,
                                        backgroundColor: COLORS.gray[200],
                                        paddingHorizontal: 2,
                                        paddingVertical: 8,
                                        textAlign: 'right'
                                    }}>
                                        {String(cellData || "0")}
                                    </Text>
                                </View>
                            );
                        }
                    })}
                </View>
            );
        })}
    </View>;
};

export default DashboardTablePDFII;
